import * as Yup from 'yup';

export const contactDetailPermissionsValidationSchema = Yup.object().shape({
    password: Yup.string().test(
        // can be empty or should have a minimum of 8 chars
        'zeroOrMinEight',
        'app.error.passwordLength',
        (password?: string | null) => !password || password.length >= 8
    ),
});
